import { useState, useEffect, RefObject } from 'react';
import { TREE_CONFIG } from '@/config';

interface Dimensions {
  width: number;
  height: number;
  padding: number;
}

export function useTreeDimensions(containerRef: RefObject<HTMLDivElement>) {
  const [dimensions, setDimensions] = useState<Dimensions>({
    width: window.innerWidth,
    height: Math.max(500, window.innerHeight - 200), // Minimum height of 500px
    padding: TREE_CONFIG.INITIAL_PADDING
  });

  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setDimensions({
          width: rect.width,
          height: Math.max(500, rect.height), // Ensure minimum height
          padding: TREE_CONFIG.INITIAL_PADDING
        });
      }
    };

    updateDimensions();

    // Create ResizeObserver for container
    const observer = new ResizeObserver(updateDimensions);
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    // Handle window resize
    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
      observer.disconnect();
    };
  }, [containerRef]);

  return dimensions;
}